import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from './IELTSCourse';
import { listeningDetailsData, getDataForDifficulty } from './data/skills/listening/listeningDetails';

export default function ListeningForDetails() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : listeningDetailsData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
